import { ICode } from '@src/model/common/Code';

export interface IUserType extends ICode<UserTypeEnum> {}

export enum UserTypeEnum {
  LOCAL = '1',
  LDAP = '2',
}
